import React from 'react';

interface AlertModalProps {
  title?: string;
  message: string;
  type?: 'success' | 'error' | 'info' | 'warning';
  /** Optional external URL to open in a new tab (e.g. an OAuth re-authorize link). */
  actionUrl?: string;
  /** Label for the action button. Defaults to "Open". */
  actionLabel?: string;
  onClose: () => void;
}

const AlertModal: React.FC<AlertModalProps> = ({
  title,
  message,
  type = 'info',
  actionUrl,
  actionLabel,
  onClose,
}) => {
  const defaultTitle =
    type === 'success'
      ? 'Success'
      : type === 'error'
        ? 'Error'
        : type === 'warning'
          ? 'Warning'
          : 'Info';
  const displayTitle = title || defaultTitle;

  return (
    <div className="modal-overlay" role="presentation" onClick={onClose}>
      <div className="modal-content alert-modal" role="alertdialog" aria-modal="true" aria-labelledby="alert-modal-title" onClick={(e) => e.stopPropagation()}>
        <div className={`modal-header alert-header-${type}`}>
          <h3 id="alert-modal-title">{displayTitle}</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <p className="alert-message" style={{ whiteSpace: 'pre-line' }}>{message}</p>
        </div>
        <div className="modal-footer">
          {actionUrl && (
            <a
              href={actionUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-save"
              style={{ marginRight: 8, textDecoration: 'none', display: 'inline-block' }}
            >
              {actionLabel || 'Open'}
            </a>
          )}
          <button className="btn-save" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
